type PositionJsxOverCanvasProps = {
  fabricObject: fabric.Object;
  element: HTMLElement;
  canvasZoom: number;
};

export const positionJsxOverFabric = async ({ fabricObject, element, canvasZoom }: PositionJsxOverCanvasProps) => {
  if (!canvasZoom || !element) {
    throw new Error('Canvas or element reference are not defined');
  }

  const boundingBox = fabricObject.getBoundingRect();
  const { top, left, height, width } = boundingBox;

  const { angle } = fabricObject;
  const zoomedAngle = angle ? angle * canvasZoom : 0;

  element.style.left = `${left}px`;
  element.style.top = `${top}px`;
  element.style.width = `${width}px`;
  element.style.height = `${height}px`;
  element.style.transform = `rotate(${zoomedAngle}deg)`;

  return { element };
};
